import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, LoadingController, ModalController, NavController, NavParams } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGeradorPage } from '../../form-gerador/form-gerador.page';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';


@Component({
  selector: 'app-cadastro-busca-codigo',
  templateUrl: './cadastro-busca-codigo.page.html',
  styleUrls: ['./cadastro-busca-codigo.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule
  ],
})
export class CadastroBuscaCodigoPage implements OnInit {

  validations_form: FormGroup;
  error: boolean = false;
  facebook: any = {};

  constructor(
    public navCtrl: NavController,
    public formBuilder: FormBuilder,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    private loadingController: LoadingController,
    private router: Router,
    private location: Location,
  ) {
    this.validations_form = this.formBuilder.group({
      codigo: new FormControl('', Validators.required)
    });

    // this.facebook = this.navParams.get('facebook');
  }

  ngOnInit() {
  }


  validation_messages = {
    'codigo': [
      { type: 'required', message: this.translate.instant('O código deve ser informado') }
    ]
  };

  onSubmit(form: { codigo: any; }) {
    this.userProvider.validarCodigoIgreja(form.codigo).subscribe(async data => {
      if (data) {
        const cadastro: any = {};
        cadastro.form = 'APP_CAD_INICIO';
        cadastro.idPessoaTipo = 5;
        cadastro.titulo = this.translate.instant('Novo Cadastro');
        cadastro.idInstituicao = data.id;
        // cadastro.facebook = this.facebook;
        this.userProvider.idInstituicao = data.id;

        const modalCadastro = await this.modalCtrl.create({ component: FormGeradorPage, componentProps: cadastro, animated: false });
        modalCadastro.present();

        const result = await modalCadastro.onDidDismiss();
        if (result.data) {
          this.modalCtrl.dismiss(result.data);
        }

      } else {
        //loader.dismiss();
        this.error = true;
      }
    });
  }

  public mudarCodigo() {
    this.error = false;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
